<template>

    <div class="footer">
        <div class="container">

            <div class="row">
                <div class="col-sm-6 col-md-4">
                    <div class="nav flex-column">
                        <div class="nav-item"><span class="nav-title">Product</span></div>
                        <div class="nav-item"><a class="nav-link" :href="appUrl + '/signup'">Start Free Trial</a></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('pricing')">Pricing</a></div>
                        <div class="nav-item"><a class="nav-link" href="https://docs.crowdpower.io" target="_blank">Docs</a></div>
                        <div class="nav-item"><a class="nav-link" href="https://bit.ly/3iYuwcu" target="_blank">REST API</a></div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4">
                    <div class="nav flex-column">
                        <div class="nav-item"><span class="nav-title">Connect</span></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('contact')">Contact Us</a></div>
                        <div class="nav-item"><a class="nav-link" href="https://saastic.com/showcase/crowdpower" target="_blank">Customer Reviews</a></div>
                        <div class="nav-item"><a class="nav-link" href="https://twitter.com/crowdpowerhq" target="_blank">Follow on Twitter</a></div>
                    </div>
                </div>
                <div class="col-sm-6 col-md-4">
                    <div class="nav flex-column">
                        <div class="nav-item"><span class="nav-title">Policies</span></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('privacy')">Privacy Policy</a></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('terms')">Terms of Service</a></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('security')">Security</a></div>
                        <div class="nav-item"><a class="nav-link" href="#" @click.prevent="push('privacy-regulations')">Privacy Regulations (GDPR)</a></div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col d-flex flex-column align-items-center">
                    <a class="mt-30 mb-30" href="https://www.capterra.com/reviews/206723/CrowdPower?utm_source=vendor&utm_medium=badge&utm_campaign=capterra_reviews_badge">
                        <img border="0" src="https://assets.capterra.com/badge/e6277500900b05fe8e2c43e59c01a5c1.png?v=2148223&p=206723" />
                    </a>
                    <span class="legal">&copy; {{ year }} SJW Group, Inc.</span>
                </div>
            </div>

        </div>
    </div>

</template>

<style scoped lang="scss">

    .footer {

        background: $color-bg;
        flex-shrink: 0;
        min-height: 300px;
        padding: 80px 0;

        .nav {
            text-align: center;
            margin: 0 0 15px 0;
            .nav-item {
                margin: 0 0 10px 0;
                padding: 0;
            }
            .nav-title {
                @include font-semibold(13px);
                color: $color-text;
                line-height: 1.6em;
            }
            .nav-link {
                @include font-medium(13px);
                color: $color-link;
                line-height: 1.6em;
                padding: 0;
                transition: color .3s;
                @media (hover: hover) {
                    &:hover {
                        color: $color-link-hover;
                    }
                }
            }
        }

        .legal {
            @include font-medium(12px);
            color: $color-text;
            text-align: center;
        }

    }

</style>

<script>

import moment from 'moment';

export default {

    data() {
        return {
            appUrl: process.env.VUE_APP_APP_URL,
            year: moment().format('Y'),
        }
    },

    methods: {

        push(name) {
            if (this.$route.name !== name) {
                this.$router.push({ name: name });
            }
        },

        chat() {
            window.Beacon('open');
        },

    },

}

</script>